import { computed, getCurrentInstance } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import { MUTATION_TYPES } from "@/store/const";
import { StateRoot } from "@/store/state";
import providers from "@/lib/api";
import { getStorageNSFWUserSettings, setNSFWUserSettings } from "@/lib/nsfwHelpers";
import config from "@/config";

export default function useNSFWUserSettings() {
  const vm = getCurrentInstance();
  const { authUser } = useAuthUser();

  const nSFWUserSettings = computed(() => (vm ? (vm.$store.state as StateRoot).nSFWUserSettings ?? null : null));
  const showNotSafeForWork = computed(() => (!config.featureNSFW ? true : !!nSFWUserSettings.value));
  const updateNSFWUserSettings = async (value: boolean) => {
    if (authUser.value) {
      await providers.NSFWSettingsProvider.updateUserSettings({
        data: { userId: authUser.value?.id, showNotSafeForWork: value },
      });
    } else {
      setNSFWUserSettings(value);
    }
    vm?.$store.commit(MUTATION_TYPES.SET_NSFW_USER_SETTING, value);
  };

  const init = () => {
    if (!authUser.value) {
      const value = getStorageNSFWUserSettings();
      vm?.$store.commit(MUTATION_TYPES.SET_NSFW_USER_SETTING, value);
    }
  };

  return {
    showNotSafeForWork,
    nSFWUserSettings,
    init,
    updateNSFWUserSettings,
  };
}
